<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-13 15:27:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-20 09:54:23
 * @FilePath: /goldenSalesMobile/src/App.vue
 * @Description:
-->
<template>
  <div id="app">
    <router-view />
    <tabBar
      :datas="tabbarConfig"
      :tabbarIndex="tabbarIndex"
      v-if="tabbarShow"
    ></tabBar>
  </div>
</template>

<script>
import { getUrlParam, handleLocalStorage } from "@/utils/index";
import { getOpenId } from "@/api/user";
// TODO 更新测试环境需注意
import { testGetAESPhone } from "@/api/user";
import { setToken, getToken } from "@/utils/auth";
import wxConfig from "@/utils/wxConfig.js";
import { getWetWechatCustomPage } from "@/api/member";
import { testUrl } from "@/utils/http.js";
import { tabbarConfig } from "@/utils/testJson";
export default {
  name: "Index",
  data() {
    return {
      tabbarShow: false,
      // 使用tabbar的页面数组
      // tabbarUsePage: [
      //   {
      //     linkTitle: "首页",
      //     linkUrl: "homePage/homePage",
      //     linkMiniProgram: "customPage/homePage/homePage",
      //   },
      //   {
      //     linkTitle: "团购",
      //     linkUrl: "homePage/groupMall",
      //     linkMiniProgram: "pages/groupMall/groupMall",
      //   },
      //   {
      //     linkTitle: "我的订单",
      //     linkUrl: "homePage/order",
      //     linkMiniProgram: "pages/orderList/orderList",
      //   },
      //   {
      //     linkTitle: "个人中心",
      //     linkUrl: "homePage/personCenter",
      //     linkMiniProgram: "customPage/homePage/homePage?page=2",
      //   },
      // ],
      tabbarConfig: {}, //tabbar组件配置
      tabbarIndex: 0,
    };
  },
  async created() {
    wxConfig.blockingWechatSharing(this);
    let pathCode = window.location.pathname.slice(1);
    console.log(window.location);
    this.pathCode = pathCode;
    this.$store.commit("setStoreVal", { vpnNumber: pathCode });
    const lastVpnNumber = localStorage.getItem("vpnNumber");
    localStorage.setItem("vpnNumber", pathCode);
    if (lastVpnNumber && lastVpnNumber != pathCode) {
      this.$pub.setS("clearAll", true, true);
      this.$pub.clearS();
      location.reload();
    }
    let token = getToken();
    if (token) {
      this.handleGetWetWechatCustomPageConfig();
    } else {
      let retryCount = 0;
      const maxRetries = 60;
      let timeId = setInterval(() => {
        retryCount += 1;
        console.log("定时获取token");
        let tokenData = getToken();
        if (tokenData) {
          clearInterval(timeId);
          this.handleGetWetWechatCustomPageConfig();
        } else if (retryCount >= maxRetries) {
          clearInterval(timeId);
          console.warn("获取 token 超时，请检查登录接口是否正常");
        }
      }, 500);
    }

    this.init();
  },

  mounted() {},
  // computed: {
  //   //根据后台配置展示tabbar
  //   tabbarShow() {
  //     return false;
  //   },
  // },
  watch: {
    $route(to, from) {
       if((to.fullPath+"").includes("/MinMember/ValidMember?returnurl")){
            console.log("to页面对象-------"+to.fullPath);
            handleLocalStorage.set('returnurl',to.fullPath)
       }else {
            handleLocalStorage.set('returnurl','')
       }

      console.log(to);
      let that = this;
      setTabbar();
      function setTabbar() {
        if (Object.keys(that.tabbarConfig).length !== 0) {
          if (
            that.tabbarConfig.imageList &&
            that.tabbarConfig.imageList.length > 0
          ) {
            let nowPath = to.redirectedFrom || to.path;
            if (to.fullPath == "/customHomePage?page=1") {
              nowPath = "/homePage/homePage";
            } else if (to.fullPath == "/customHomePage?page=2") {
              nowPath = "/homePage/personCenter";
            }
            const pageItem = that.tabbarConfig.usePages.find(
              (item) => nowPath == "/" + item.linkUrl
            );

             that.tabbarShow = pageItem ? true : false;
             // that.tabbarShow =  true ;
            const findNowIndex = that.tabbarConfig.imageList.findIndex(
              (item) => item.linkUrl.split("#")[1] == nowPath
            );
            that.tabbarIndex = findNowIndex != -1 ? findNowIndex : 0;
          }
        } else {
          setTimeout(() => {
            setTabbar();
          }, 500);
        }
      }
    },
  },
  methods: {
    async init() {
      const tcColor = await this.setThemeColor();
      this.$store.commit("set_themecolor", tcColor);
      //在页面加载时读取localStorage里的状态信息。 如果本地有设置clearAll属性true。 就清除store。 否则使用缓存的store数据
      if (localStorage.getItem("store")) {
        if (localStorage.getItem("clearAll")) {
          localStorage.removeItem("clearAll");
        } else {
          this.$store.replaceState(
            Object.assign(
              {},
              this.$store.state,
              JSON.parse(localStorage.getItem("store")),
              { vpnNumber: this.pathCode }
            )
          );
        }
      }

      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload", () => {
        console.log("卸载卸载");
        // 刷新将点餐连接状态清除。
        this.$store.state.pointConnet = null;
        localStorage.setItem("store", JSON.stringify(this.$store.state));
      });
      // 刷新将点餐连接状态清除。仅ios
      window.addEventListener("pagehide", () => {
        this.$store.state.pointConnet = null;
        localStorage.setItem("store", JSON.stringify(this.$store.state));
      });
    },
    setThemeColor() {
      return new Promise((resolve, reject) => {
        // let tcColor = '#69748C'; // 红色
        // let tcColor = '#FAAF18'; // 橙色
        // let tcColor = "#CCA567";//金色
        let tcColor = "#333"; //黑色

        // tcColor = 'lightblue'; // 浅蓝色
        // tcColor = 'blue'; // 蓝色
        // tcColor = 'green'; // 绿色
        document.body.style.setProperty("--tc", tcColor);
        // setS('tc', tcColor);
        resolve(tcColor);
      });
    },
    handleGetWetWechatCustomPageConfig() {
      getWetWechatCustomPage({
        VpnNumber: this.pathCode,
        Page: 3,
      }).then((res) => {
        if (res) {
          const configData = res[0];

          if (configData.Body) {
            this.tabbarConfig = JSON.parse(configData.Body);
          } else {
            this.tabbarConfig = {};
          }
        } else {
          this.tabbarConfig = {};
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  /* IOS禁止微信调整字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  font-family: "PingFangSC-Regular", "Avenir", Helvetica, Arial, sans-serif;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666666;
  background: #f7f7f7;
  min-height: 100vh;

  box-sizing: border-box;
}

img {
  object-fit: cover;
}
</style>
